// extracted by mini-css-extract-plugin
export default {"SecuritySummaries":"B205SOtCJQmTDM_HeP0Y","h2":"WXSwK4g8CasLNDMONMiR"};